import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { MooneIcon } from "Components/Shared/Icons/MooneIcon";
import { Link } from "Navigation/Link";
import type { ReactNode } from "react";

type Props = {
  title: string;
  subtitle: string;
  icon?: ReactNode;
  to: string;
  children?: ReactNode;
  target?: string;
};

export const ItemCardLink = ({
  title,
  subtitle,
  icon,
  to,
  children,
  target,
}: Props) => {
  const defaultIcon = icon ?? <MooneIcon sx={{ color: "grey.600" }} />;

  const linkProps = {
    component: Link,
    to,
    target,
  };

  // TODO: fast solution - with children means there's the link with copy button, so the whole card cant be clickable anymore.
  // This should be later refactored, since its a shared component
  const isWholeCardClickable = !children;

  return (
    <Paper
      {...(isWholeCardClickable ? linkProps : {})}
      sx={{
        gap: 2,
        display: "flex",
        borderRadius: 2,
        alignItems: "center",
        textDecoration: "none",
        padding: ({ spacing }) => spacing(2, 3),
        transition: "box-shadow 0.2s ease-in-out",
        "&:hover": isWholeCardClickable
          ? { boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)" }
          : {},
      }}
    >
      <Stack width="100%" gap={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width={48}
              height={48}
              borderRadius="50%"
              sx={{ backgroundColor: "grey.200" }}
            >
              {defaultIcon}
            </Box>
            <Stack flex={1} minWidth={0} gap={0.5}>
              <Box
                {...(isWholeCardClickable ? {} : linkProps)}
                sx={{
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  "&:hover": isWholeCardClickable ? {} : { opacity: 0.8 },
                }}
              >
                <Typography fontWeight={600} color="primary.main" fontSize={16}>
                  {title}
                </Typography>
              </Box>
              <Typography color="text.secondary" fontSize={14}>
                {subtitle}
              </Typography>
            </Stack>
          </Box>
          <Box
            {...(isWholeCardClickable ? {} : linkProps)}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              textDecoration: "none",
              color: "primary.main",
              cursor: "pointer",
              "&:hover": isWholeCardClickable ? {} : { opacity: 0.8 },
            }}
          >
            <ArrowForwardIcon />
          </Box>
        </Box>
        {children}
      </Stack>
    </Paper>
  );
};
